import React from 'react';
import uiActions from 'tradera/state/ui/actions';
import {
    closeCategoryDropdownMenu,
    closeProfileMenu,
    openProfileMenu
} from 'tradera/state/ui/reducer';
import { ProfileMenu } from '../profile-menu/profile-menu';
import { ProfileLink } from './profile-link';
import { useUrlLocalizer } from 'tradera/lang/translate';
import { MODAL_STATE } from 'tradera/constants/ui';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';

export const ProfileMenuLink = ({ transparentHeader }) => {
    const { isLoggedIn } = useAppSelector((state) => state.member);
    const { type: pageName } = useAppSelector((state) => state.page);
    const { profileMenu } = useAppSelector((state) => state.ui);
    const dispatch = useAppDispatch();

    const { toLocalizedUrl } = useUrlLocalizer();
    const handleLoginClick = (redirectUrl = false) =>
        dispatch(
            uiActions.signIn({ redirectUrl: toLocalizedUrl(redirectUrl) })
        );

    // Prevent Default and show login, if not logged in
    const preventNavigationAndShowLogin = (event, redirect) => {
        if (!isLoggedIn) {
            event.preventDefault();
            handleLoginClick(redirect);
        }
    };

    const handleProfileClick = (evt) => {
        if (profileMenu.open === MODAL_STATE.OPEN) {
            dispatch(closeProfileMenu());
        } else {
            dispatch(closeCategoryDropdownMenu());

            // not logged in
            if (!isLoggedIn) {
                preventNavigationAndShowLogin(evt, false);
                return;
            } else {
                dispatch(openProfileMenu());
            }
        }

        if (pageName.includes('MyTradera')) {
            window.scrollTo(0, 0);
        }
    };

    const { open: profileMenuOpen = false } = profileMenu;

    return (
        <>
            <ProfileLink
                handleProfileClick={handleProfileClick}
                menuExpanded={profileMenuOpen === MODAL_STATE.OPEN}
                transparentHeader={transparentHeader}
            />
            <ProfileMenu
                expanded={profileMenuOpen === MODAL_STATE.OPEN}
                handleExpand={handleProfileClick}
                transparentHeader={transparentHeader}
            />
        </>
    );
};
